import { render, staticRenderFns } from "./BatchDeletion.vue?vue&type=template&id=08025cda&scoped=true"
import script from "./BatchDeletion.vue?vue&type=script&lang=js"
export * from "./BatchDeletion.vue?vue&type=script&lang=js"
import style0 from "./BatchDeletion.vue?vue&type=style&index=0&id=08025cda&prod&lang=stylus&scoped=true"
import style1 from "./BatchDeletion.vue?vue&type=style&index=1&id=08025cda&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08025cda",
  null
  
)

export default component.exports